import { render, staticRenderFns } from "./Option.vue?vue&type=template&id=7c95d1a1&scoped=true&"
import script from "./Option.vue?vue&type=script&lang=ts&"
export * from "./Option.vue?vue&type=script&lang=ts&"
import style0 from "./Option.vue?vue&type=style&index=0&id=7c95d1a1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c95d1a1",
  null
  
)

export default component.exports